import DateFormat from 'src/utils/dateFormat';
import htmlParse from 'html-react-parser';
import moment from 'src/utils/moment';
import SubstitutionInfoItem from 'src/components/Items/SubstitutionInfoItem';
import useStyles from './style';
import { getUserRole } from 'src/utils/useUser';
import { handleSum } from 'src/utils/useFunctions';
import { useAppSelector } from '../../../../../hooks/redux-hooks';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

const Substitutions: React.FunctionComponent = () => {

  const { t } = useTranslation();
  const classes = useStyles();
  const languageData = useAppSelector((state: any) => state.language);
  const substitutionsData = useAppSelector((state: any) => state.substitutions);
  const userData = useAppSelector((state: any) => state.user);
  const childData = substitutionsData.childData;
  const curChild = substitutionsData.currentChild;

  const parseDay = (day: any) => {
    if(day === 0) return 7;
    else return day;
  };

  const getDaySubstitutionData = (date: any) => {
    const isExist = substitutionsData.list.filter((item: any) => item.childID === curChild.childID).length > 0 ? substitutionsData.list.find((item: any) => item.childID === curChild.childID).dates.filter((item: any) => item.date === moment(date).format("YYYY-MM-DD")).length === 1 : false;
    if(isExist) {
      const substitutionData = substitutionsData.list.find((item: any) => item.childID === curChild.childID).dates.find((item: any) => item.date === moment(date).format("YYYY-MM-DD"));
      return substitutionData;
    } else {
      return [];
    }
  };

  const getDayWatchdogData = (date: any) => {
    const isExist = substitutionsData.watchdogs.filter((item: any) => item.childID === curChild.childID).length > 0 ? substitutionsData.watchdogs.find((item: any) => item.childID === curChild.childID).dates.filter((item: any) => item.date === moment(date).format("YYYY-MM-DD")).length === 1 : false;
    if(isExist) {
      const watchdogData = substitutionsData.watchdogs.find((item: any) => item.childID === curChild.childID).dates.find((item: any) => item.date === moment(date).format("YYYY-MM-DD"));
      return watchdogData;
    } else {
      return [];
    }
  };

  const getDateCredit = useCallback((date: any, customAllDays?: any, customSchoolDays?: any) => {
    const allDays = customAllDays ? customAllDays : substitutionsData.childData.allDays;
    const schoolDays = customSchoolDays ? customSchoolDays : substitutionsData.childData.schoolDays;
    const credits = allDays.filter((item: any) => item.substitutionRemaining && moment(item.date).isBetween(moment(date).subtract(schoolDays, 'days'), moment(date).add(schoolDays, 'days')) && moment(item.date).isBefore(moment(date),'day')).map((item: any) => {
      return item.substitutionRemaining;
    }).reduce(handleSum, 0);
    return credits;
  }, [substitutionsData.childData.allDays, substitutionsData.childData.schoolDays]);

  const getFirstAvailableDay = useCallback(() => {
    if(childData) {
      const prevDays = moment().subtract(childData.schoolDays, 'days');
      const nextDays = moment().add((180 + childData.schoolDays), 'days');
      let currentDate = prevDays.clone();
      while(currentDate.isBefore(nextDays, 'day')) {
        const parsedDay = parseDay(moment(currentDate).day());
        const isValid = (getDateCredit(currentDate, childData.allDays, childData.schoolDays) > 0 && moment(currentDate).isAfter(moment(), 'days') && moment(currentDate).isSameOrBefore(moment(childData.lastDay).add(childData.schoolDays,'days'), 'days') && (childData.attendanceProgram.days.filter((day: any) => day.day === parsedDay).length === 0 || (childData.attendanceProgram.days.filter((day: any) => day.day === parsedDay).length !== 0 && childData.attendanceProgram.days.find((day: any) => day.day === parsedDay).attendanceType !== "all")) && childData.workingDays.indexOf(parsedDay) !== -1 && childData.holidayDates.indexOf(parsedDay) === -1 && childData.allDates.indexOf(parsedDay) === -1) && (getDaySubstitutionData(currentDate).length === 0 || (getDaySubstitutionData(currentDate).substitutionPartID !== 1 && childData.attendanceProgram.days.filter((day: any) => day.day === parsedDay).length === 0)) && (getDayWatchdogData(currentDate).length === 0 || (getDayWatchdogData(currentDate).dayPart !== 1 && childData.attendanceProgram.days.filter((day: any) => day.day === parsedDay).length === 0));
        if(isValid) {
          return currentDate.format("YYYY-MM-DD");
        }
        currentDate = currentDate.add(1, 'day');
      }
      return null;
    }
  }, [childData, getDateCredit]);

  const getLastAvailableDay = useCallback(() => {
    if(childData) {
      const prevDays = moment().subtract(childData.schoolDays, 'days');
      const nextDays = moment().add((180 + childData.schoolDays), 'days');
      let currentDate = nextDays.clone();
      while (currentDate.isAfter(prevDays, 'day')) {
        const parsedDay = parseDay(moment(currentDate).day());
        const isValid = getDateCredit(currentDate, childData.allDays, childData.schoolDays) > 0 && currentDate.isAfter(moment(), 'days') && currentDate.isSameOrBefore(moment(childData.lastDay).add(childData.schoolDays, 'days'), 'days') && (childData.attendanceProgram.days.filter((day: any) => day.day === parsedDay).length === 0 || (childData.attendanceProgram.days.filter((day: any) => day.day === parsedDay).length !== 0 && childData.attendanceProgram.days.find((day: any) => day.day === parsedDay).attendanceType !== "all")) && childData.workingDays.indexOf(parsedDay) !== -1 && childData.holidayDates.indexOf(parsedDay) === -1 && childData.allDates.indexOf(parsedDay) === -1 && (getDaySubstitutionData(currentDate).length === 0 || (getDaySubstitutionData(currentDate).substitutionPartID !== 1 && childData.attendanceProgram.days.filter((day: any) => day.day === parsedDay).length === 0)) && (getDayWatchdogData(currentDate).length === 0 || (getDayWatchdogData(currentDate).dayPart !== 1 && childData.attendanceProgram.days.filter((day: any) => day.day === parsedDay).length === 0));
        if(isValid) {
          return currentDate.format("YYYY-MM-DD");
        }
        currentDate = currentDate.subtract(1, 'day');
      }
      return null;
    }
  }, [childData, getDateCredit]);

  return (
    <>
      <div className={classes.row}>
        <p className={classes.text}>
          {t('substitutions_info')}  
        </p>
      </div>
      {
        getUserRole(userData.userObject.roleType) === "parent" ? (
          <>
            <div className={classes.row}>
              <div className={classes.block}>
                <span className={classes.title}>
                  {t('substitutions_credits')}
                </span>
                <p className={classes.text}>
                  {htmlParse(t('substitutions_available_description', {available: '<b>' + childData.credit + '</b>', excuse_notes: '<b>' + childData.allDates.length + '</b>', days: '<b>' + childData.schoolDays + '</b>'}))}  
                </p>
                {
                  childData.credit > 0 ? (
                    <p className={classes.text}>
                      {(getFirstAvailableDay() && getLastAvailableDay) ? htmlParse(t('substitutions_available_dates_description', {firstAvailableDate: DateFormat(getFirstAvailableDay(), "default", languageData, t), lastAvailableDate: DateFormat(getLastAvailableDay(), "default", languageData, t)})) : t('substitutions_not_available_dates_description')}
                    </p>
                  ) : null
                }
              </div>
              <div className={classes.block}>
                <span className={classes.title}>
                  {t('substitutions_rules')}
                </span>
                <div className={classes.text}>
                  {t('substitutions_rules_description')}
                  <ul>
                    <li>{t('substitutions_rules_date_past')}</li>
                    <li>{t('substitutions_rules_schools_enabled')}</li>
                    <li>{t('substitutions_rules_schools_workdays')}</li>
                    <li>{t('substitutions_rules_schools_holidays')}</li>
                    <li>{t('substitutions_rules_children_attendance')}</li>
                    <li>{t('substitutions_rules_children_excuse_notes')}</li>
                    <li>{t('substitutions_rules_children_substitutions')}</li>
                    <li>{t('substitutions_rules_children_watchdogs')}</li>
                    <li>{t('substitutions_rules_children_attendance_full_day')}</li>
                    <li>{t('substitutions_rules_children_credit')}</li>
                  </ul>  
                </div>
              </div>
            </div>
            <div className={classes.row}>
              <div className={classes.block}>
                <span className={classes.title}>
                  {t('substitutions_badges')}
                </span>
                <span className={classes.subTitle}>
                  {t('attendance_programme')}
                </span>
                <div className={classes.badges}>
                  <SubstitutionInfoItem morningStatus="attendance" text={t('morning')}/>
                  <SubstitutionInfoItem afternoonStatus="attendance" text={t('afternoon')}/>
                  <SubstitutionInfoItem morningStatus="attendance" afternoonStatus="attendance" text={t('whole_day')}/>
                </div>
                <span className={classes.subTitle}>
                  {t('substitution')}
                </span>
                <div className={classes.badges}>
                  <SubstitutionInfoItem morningStatus="substitution" text={t('morning')}/>
                  <SubstitutionInfoItem afternoonStatus="substitution" text={t('afternoon')}/>
                  <SubstitutionInfoItem morningStatus="substitution" afternoonStatus="substitution" text={t('whole_day')}/>
                </div>
                <span className={classes.subTitle}>
                  {t('watchdog')}
                </span>
                <div className={classes.badges}>
                  <SubstitutionInfoItem morningStatus="watchdog" text={t('morning')}/>
                  <SubstitutionInfoItem afternoonStatus="watchdog" text={t('afternoon')}/>
                  <SubstitutionInfoItem morningStatus="watchdog" afternoonStatus="watchdog" text={t('whole_day')}/>
                </div>
                <span className={classes.subTitle}>
                  {t('substitution_create')}
                </span>
                <div className={classes.badges}>
                  <SubstitutionInfoItem morningStatus="create" text={t('morning')}/>
                  <SubstitutionInfoItem afternoonStatus="create" text={t('afternoon')}/>
                  <SubstitutionInfoItem morningStatus="create" afternoonStatus="create" text={t('whole_day')}/>
                </div>
              </div>
            </div>
            <div className={classes.row}>
              <div className={classes.block}>
                <span className={classes.title}>
                  {t('substitutions_combinations')}
                </span>
                <p className={classes.text}>
                  {t('substitutions_combinations_description')}  
                </p>
                <div className={classes.badges}>
                  <SubstitutionInfoItem morningStatus="attendance" afternoonStatus="create" text={t('morning')}/>
                  <SubstitutionInfoItem morningStatus="create" afternoonStatus="attendance" text={t('afternoon')}/>
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className={classes.row}>
            <div className={classes.fullblock}>
              <span className={classes.title}>
                {t('substitutions_teacher_director')}
              </span>
              <p className={classes.text}>
                {getUserRole(userData.userObject.roleType) === "teacher" ? t('substitutions_teacher_description') : t('substitutions_director_description')}  
              </p>
            </div>
          </div>
        )
      }
    </>
  );
};

export default Substitutions;